import React from 'react'
import { Text } from '../Text'
import d from '../../assets/img/icon/q-4.png'
import dna from '../../assets/img/icon/q-3.png'
import exc from '../../assets/img/icon/q-2.png'
import { useNavigate } from 'react-router-dom'

export default function MegaMenu1 () {
  const navigate = useNavigate()
  const data1 = [
    {
      userImage: d,
      title: 'Эсийн банк',
      description:
        'Хүйн цус болон хүйн эд нь үүдэл эсийн хосгүй эх үүсвэр бөгөөд эдгээр эсүүдийг ирээдүйд төрөл бүрийн өвчнийг эмчлэхэд ашиглах боломжтой. Манай эмнэлэг хүйн цуснаас болон хүйн эдээс үүдэл эсийг өндөр технологиор ялган авч, олон жилийн туршид чанарын алдагдалгүй хадгалах нөхцөлийг бүрдүүлдэг',
      menu: 'cellbank'
    },
    {
      userImage: exc,
      title: 'Эсийн эмчилгээ',
      description:
        'Хүний биеийн бүтэц, үйл ажиллагааны үндсэн нэгж болох эс нь байгалиас заяасан орлуулшгүй үнэтэй эмчилгээний эх үүсвэр юм. Эсийн эмчилгээ нь хавдар, аутоиммун өвчин, эрхтэн шилжүүлэн суулгалтын дараах дархлаа зохицуулалт, хөгшрөлтийн эсрэг үйлчилгээ, шархны эдгэрэлтийг хурдасгах болон нөхөн сэргээх анагаах ухааны гол түлхүүр болж байна.',
      menu: 'therapy'
    },
    {
      userImage: dna,
      title: 'Генетик шинжилгээ',
      description: 'Генетикийн шинжилгээ хийлгэснээр та өөрийн болон гэр бүлийнхээ эрүүл мэндийг урьдчилан хамгаалах боломжтой.',
      menu: 'genetic'
    }
  ]
  const handleMenu = menu => {
    navigate(`/${menu}`)
    window.scrollTo(0, 0) 
  }

  return (
    <div
      className='absolute top-auto z-[99] min-w-[336px] pt-[0.75rem] '
      style={{ left: '-20px', transform: 'translate(-25%, -5%)' }}
    >
      <div className='w-full rounded-lg bg-white-a700 p-[1.25rem] shadow-2x1'>
        <div
          className='flex gap-[1.88rem] flex-col'
          style={{ backgroundColor: 'white', padding: 20, borderRadius: 16 }}
        >
          {data1.map((item, index) => (
            <div
              key={index}
              className='flex flex-column items-start gap-[1.00rem] sm:gap-[1.00rem] cursor-pointer'
              onClick={() => handleMenu(item.menu)}
            >
              <img
                src={item.userImage}
                alt='user'
                className='w-[24px] h-[24px]'
              />
              <div className='flex flex-col'>
                <Text className='text-[16px] text-black '>{item.title}</Text>
                <p className='text-black/55 text-[14px]'>
                  {item.description.length > 50
                    ? `${item.description.slice(0, 50)}...`
                    : item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
